import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import request from 'request';

import { CopyToClipboard } from 'react-copy-to-clipboard';

//get direct reference to firebase so we can create separate fb instance for testing
import firebase from 'firebase/app';
//import { INTERNAL } from 'firebase/auth';

import {
  getIcon,
  callIfFunction,
  Firebase,
  appConfig,
} from '../../util';

const NETWORK_TEST_EMAIL = 'networktest@auctusiq.com';
const NETWORK_TEST_PASSWORD = '4ynpA4V~X2CKs)B<';

class NetworkTest extends Component {

  componentWillMount(){
    //INTERNAL.forceLongPolling();
  }

  beginLoggingText(testName){
    console.log('************************');
    console.log(`${testName}:\n`);
  }

  FirebaseForTesting = firebase.initializeApp(appConfig().FIREBASE_CONFIG, "networkTest");

  /*
    All tests include:

    Ability to access localStorage & cookies (affects Edge in InPrivate)
    Ability to make network request to backend using http request (with ping) - could indicate issues with connectivity or our servers
    Ability to fetch document from Google Firestore - likely indicates issue with antivirus preventing network request due to Google Firestore request being classified as untrusted

  */
  state = {
    isTesting: false,
    testResults: null,
    auth: false,
    recentlyCopied: false,
  }

  //https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
  getBrowserAndOSInfo(){
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName  = navigator.appName;
    var fullVersion  = ''+parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion,10);
    var nameOffset,verOffset,ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
     browserName = "Opera";
     fullVersion = nAgt.substring(verOffset+6);
     if ((verOffset=nAgt.indexOf("Version"))!=-1)
       fullVersion = nAgt.substring(verOffset+8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
     browserName = "Microsoft Internet Explorer";
     fullVersion = nAgt.substring(verOffset+5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
     browserName = "Chrome";
     fullVersion = nAgt.substring(verOffset+7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
     browserName = "Safari";
     fullVersion = nAgt.substring(verOffset+7);
     if ((verOffset=nAgt.indexOf("Version"))!=-1)
       fullVersion = nAgt.substring(verOffset+8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
     browserName = "Firefox";
     fullVersion = nAgt.substring(verOffset+8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
              (verOffset=nAgt.lastIndexOf('/')) )
    {
     browserName = nAgt.substring(nameOffset,verOffset);
     fullVersion = nAgt.substring(verOffset+1);
     if (browserName.toLowerCase()==browserName.toUpperCase()) {
      browserName = navigator.appName;
     }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
       fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
       fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
     fullVersion  = ''+parseFloat(navigator.appVersion);
     majorVersion = parseInt(navigator.appVersion,10);
    }

    return ''
     +'Browser name  = '+browserName+' / '
     +'Full version  = '+fullVersion+' / '
     +'Major version = '+majorVersion+' / '
     +'navigator.appName = '+navigator.appName+' / '
     +'navigator.appVersion = '+navigator.appVersion+' / '
     +'navigator.userAgent = '+navigator.userAgent+'';
  }

  componentDidUpdate(){
    if( this.state.isTesting &&
        this.props.testStatuses &&
        this.props.testStatuses.browser !== undefined &&
        this.props.testStatuses.localStorage !== undefined &&
        this.props.testStatuses.network !== undefined &&
        this.props.testStatuses.functions !== undefined &&
        this.props.testStatuses.dbread !== undefined
    ){
      this.setState({
        isTesting: false,
      });
    }
  }

  updateTestResult(testName, status, data, callback){
    console.log('updateTestResult', testName, data);
    this.setState({
      testStatuses: {
        ...this.state.testStatuses,
        [testName]: status
      },
      testResults: {
        ...this.state.testResults,
        [testName]: data
      },
    }, () => {
      //enforce 250ms to results don't seem instant
      setTimeout(() => {
        callIfFunction(callback);
      }, 250);
    });
  }

  beginBrowserTest(callback){
    this.beginLoggingText('BrowserTest');
    try{

      const browserInfo = this.getBrowserAndOSInfo();

      this.updateTestResult('browser', 'success', browserInfo, callback);
    }
    catch(err){
      this.updateTestResult('browser', 'fail', err, callback);
    }
  }

  beginLocalStorageTest(callback){
    this.beginLoggingText('LocalStorageTest');
    try{

      localStorage.setItem('localStorageTest', 'Hello World!');

      this.updateTestResult('localStorage', 'success', null, callback);
    }
    catch(err){
      this.updateTestResult('localStorage', 'fail', err, callback);
    }
  }

  beginNetworkPingTest(callback){
    this.beginLoggingText('NetworkPingTest');
    try{

      request({
        method: 'GET',
        uri: `${appConfig().API_URL}/ping`,
        body: {

        },
        json: true,
        headers: {

        }
      }, (err, resp, body) => {
        if(!err && body && body.pong){
          this.updateTestResult('network', 'success', true, callback);
        }
        else{
          this.updateTestResult('network', 'fail', { err: (err || {}).message, resp, body }, callback);
        }
      });
    }
    catch(err){
      this.updateTestResult('network', 'fail', err, callback);
    }
  }

  beginNetworkFunctionsTest(callback){
    this.beginLoggingText('NetworkFunctionsTest');
    try{

      const callable = Firebase.functions().httpsCallable('pingFunction');

      callable({  }).then(result => {
        this.updateTestResult('functions', 'success', result, callback);
      }).catch(err => {
        this.updateTestResult('functions', 'fail', err, callback);
      });
    }
    catch(err){
      this.updateTestResult('functions', 'fail', err, callback);
    }
  }

  beginAuthenticationTest(callback){
    this.beginLoggingText('AuthenticationTest');
    try{

      this.FirebaseForTesting.auth().onAuthStateChanged(user => {
        if(user){
          this.updateTestResult('auth', 'success', user, callback);

          //logout?
        }
        else{
          //can't set fail here...since this is called immediately w/o user once we setup auth state subscription...
          //this.updateTestResult('auth', 'fail', 'Returned with no user data', callback);
        }
      });

      this.FirebaseForTesting.auth().signInWithEmailAndPassword(NETWORK_TEST_EMAIL, NETWORK_TEST_PASSWORD).catch(err => {
        this.updateTestResult('auth', 'fail', err, callback);
      });

    }
    catch(err){
      this.updateTestResult('auth', 'fail', err, callback);
    }
  }

  beginDatabaseReadTest(callback){
    this.beginLoggingText('DatabaseReadTest');
    try{
      Firebase.firestore().doc('tests/reads').get().then(doc => {
        console.log('fetched doc!');
        console.log(doc.data());

        if(doc && doc.data() && doc.data().read){
          this.updateTestResult('dbread', 'success', null, callback);
        }
        else{
          this.updateTestResult('dbread', 'fail', { doc, data: (doc && doc.data() ? doc.data() : null) }, callback);
        }
      }).catch(err => {
        this.updateTestResult('dbread', 'fail', err, callback);
      });
    }
    catch(err){
      this.updateTestResult('dbread', 'fail', err, callback);
    }
  }

  beginDatabaseWriteTest(callback){
    this.beginLoggingText('DatabaseWriteTest');
    try{
      Firebase.firestore().collection('tests/writes/writes').add({ written: true }).then(() => {
        console.log('wrote doc!');
        this.updateTestResult('dbwrite', 'success', null, callback);
      }).catch(err => {
        this.updateTestResult('dbwrite', 'fail', err, callback);
      });
    }
    catch(err){
      this.updateTestResult('dbwrite', 'fail', err, callback);
    }
  }

  beginTest(){
    this.setState({
      testStatuses: {},
      testResults: {},
      isTesting: true
    }, () => {
      this.beginBrowserTest(() => {
        this.beginLocalStorageTest(() => {
          this.beginNetworkPingTest(() => {
            this.beginNetworkFunctionsTest(() => {
              this.beginAuthenticationTest(() => {
                this.beginDatabaseReadTest(() => {
                  this.beginDatabaseWriteTest(() => {
                    this.setState({
                      isTesting: false,
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  render(){

    const {
      isTesting,
      testResults,
      testStatuses,
      recentlyCopied,
    } = this.state;

    const {
      browser,
      localStorage,
      network,
      functions,
      auth,
      dbread,
      dbwrite,
    } = testStatuses || {};

    return (
      <div className="page network-test">
        <h1>Network Test</h1>
        {!this.state.testResults &&
          <p>Test your device's ability to connect & communicate with our servers.</p>
        }
        {this.state.testResults &&
          <React.Fragment>
            <div className="test-frame">Browser Configuration: {(browser && browser !== 'fail') ? getIcon('check') : (browser === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
            <div className="test-frame">Local Storage: {(localStorage && localStorage !== 'fail') ? getIcon('check') : (localStorage === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
            <div className="test-frame">Network Ping: {(network && network !== 'fail') ? getIcon('check') : (network === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
            <div className="test-frame">Network Functions: {(functions && functions !== 'fail') ? getIcon('check') : (functions === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
            <div className="test-frame">Authentication Request: {(auth && auth !== 'fail') ? getIcon('check') : (auth === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
            <div className="test-frame">Database Read: {(dbread && dbread !== 'fail') ? getIcon('check') : (dbread === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
            <div className="test-frame">Database Write: {(dbwrite && dbwrite !== 'fail') ? getIcon('check') : (dbwrite === 'fail' ? getIcon('check-fail') : getIcon('check-empty'))}</div>
          </React.Fragment>
        }

        <button
          onClick={this.beginTest.bind(this)}
          className="button grey-button"
          disabled={isTesting}
        >{isTesting ? 'Testing...' : (this.state.testResults ? 'Retest' : 'Begin Test')}</button>

      {!isTesting && testResults &&
        <CopyToClipboard options={{format: "text/plain"}} text={JSON.stringify(testResults)} onCopy={() => { this.setState({ recentlyCopied: true }); setTimeout(() => { this.setState({ recentlyCopied: false }); }, 1000); }}>
          <button
            className="button primary"
          >{recentlyCopied ? 'Copied!' : 'Copy Results'}</button>
        </CopyToClipboard>
      }
      </div>
    )
  }
}

export default NetworkTest;



// WEBPACK FOOTER //
// ./src/components/public/networkTest.js